// =============================================
// COUNT-UP — Animate numeric stats on scroll
// Targets: .istat-num (impact section) & .stat-num (stat-bar)
// =============================================

(function () {
  var DURATION = 1800; // ms

  // Parse a stat string like "500k€", "4 000", "10T", "1er", "∞"
  // Returns { prefix, value, suffix, useSpaces } or null if not numeric
  function parse(text) {
    var t = text.trim();
    // Match: optional non-digit prefix, digits (with optional space thousands), optional suffix
    var m = t.match(/^([^0-9]*)([0-9][0-9 ]*)([^0-9]*)$/);
    if (!m) return null;
    var raw = m[2].replace(/\s/g, '');
    var val = parseInt(raw, 10);
    if (isNaN(val)) return null;
    return {
      prefix: m[1],
      value: val,
      suffix: m[3],
      useSpaces: /\d \d/.test(m[2])
    };
  }

  function format(n, useSpaces) {
    var s = Math.round(n).toString();
    if (useSpaces) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return s;
  }

  function animate(el, parsed) {
    var start = null;
    var to = parsed.value;

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / DURATION, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      el.textContent = parsed.prefix + format(to * eased, parsed.useSpaces) + parsed.suffix;
      if (p < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  var els = document.querySelectorAll('.istat-num, .stat-num');
  if (!els.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var parsed = parse(el.textContent);
      if (!parsed) return;
      observer.unobserve(el);
      animate(el, parsed);
    });
  }, { threshold: 0.4 });

  els.forEach(function (el) { observer.observe(el); });
})();
